
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms/reseller-agreement",
      function () {
        return require("private-next-pages/terms/reseller-agreement.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/terms/reseller-agreement"])
      });
    }
  